import React from 'react';
import './ContactsHeader.css';

function ContactsHeader({ 
  contactCount, 
  showAddForm, 
  onNavigate, 
  onToggleForm 
}) {
  return (
    <div className="contacts-header">
      <h1>My Contacts ({contactCount})</h1>
      <div className="header-actions">
        <button 
          className="dashboard-btn"
          onClick={() => onNavigate('dashboard')}
        >
          ← Dashboard
        </button>
        <button 
          className="add-contact-btn"
          onClick={onToggleForm}
        >
          {showAddForm ? 'Cancel' : '+ Add Contact'}
        </button>
      </div>
    </div>
  );
}

export default ContactsHeader;

